// frontend/src/components/SpotifyCallback.tsx
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface SpotifyCallbackProps {
  onSpotifyConnected: (spotifyUser: any) => void;
}

const SpotifyCallback: React.FC<SpotifyCallbackProps> = ({ onSpotifyConnected }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasFetched = useRef(false);

  useEffect(() => {
    // Log the entire location object for debugging
    console.log('Location object:', location);

    // Extract the authorization code and state from the URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const state = queryParams.get('state');

    // Log the code and state for debugging purposes
    console.log('Spotify auth code:', code, 'State:', state);

    if (!code) {
      console.error("No authorization code found.");
      navigate('/error', { state: { message: 'Missing Spotify authorization code.' } });
      return;
    }

    if (hasFetched.current) {
      console.log('SpotifyCallback effect ran again, but fetch already initiated. Skipping.');
      return;
    }

    // Log the environment variable and the final POST URL
    const apiUrl = process.env.REACT_APP_API_URL;
    const postUrl = `${apiUrl}/spotify/oauth-callback`;
    console.log('REACT_APP_API_URL:', apiUrl);
    console.log('Posting to:', postUrl);

    // Post the code to your backend endpoint to complete the OAuth flow
    // Try to get the Cognito token from localStorage or sessionStorage
    let token = null;
    if (localStorage.getItem('accessToken')) {
      token = localStorage.getItem('accessToken');
    } else if (sessionStorage.getItem('accessToken')) {
      token = sessionStorage.getItem('accessToken');
    }

    console.log('Attempting to retrieve accessToken from localStorage:', localStorage.getItem('accessToken'));
    console.log('Attempting to retrieve accessToken from sessionStorage:', sessionStorage.getItem('accessToken'));
    console.log('Token to be used in Authorization header:', token);

    console.log('Initiating fetch to backend API...');
    hasFetched.current = true;

    fetch(postUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ code })
    })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.error || 'Spotify connection failed.');
        }
        return response.json();
      })
      .then(data => {
        console.log('Spotify connection successful:', data);
        onSpotifyConnected(data.spotifyUser);
        navigate('/');
      })
      .catch(err => {
        console.error('Error during Spotify OAuth callback:', err.message);
        navigate('/error', { state: { message: 'Spotify connection failed.' } });
      });
  }, [location, navigate, onSpotifyConnected]);

  return (
    <div className="spotify-callback">
      <p>Connecting to Spotify, please wait...</p>
    </div>
  );
};

export default SpotifyCallback;
